module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOAQMAAAAlhr+SAAAAA1BMVEX/AAAZ4gk3AAAAC0lEQVQI12MgGgAAACoAAXbMpCAAAAAASUVORK5CYII="